<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Group</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="submitForm">
            <label>Group Name <span class="required">*</span></label>
            <input type="text" v-model="group.name" placeholder="Group Name" required>
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <!-- <label>Description</label>
            <textarea v-model="group.description" class="form-control mb-3" placeholder="Group Description"></textarea>
            <div v-if="errors.description" class="error-message">{{ errors.description[0] }}</div> -->

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/groups')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            group: { name: '', description: '' },
            isEditing: false,
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        async submitForm() {
            this.errorMessage = null;
            this.errors = {};
            try {
                if (this.isEditing) {
                    await this.$api.put(`/groups/${this.$route.params.id}`, this.group);
                } else {
                    await this.$api.post('/groups', this.group);
                }
                this.$router.push('/dashboard/groups');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the group. Please try again later.';
                }
            }
        },
        async fetchGroup() {
            if (this.$route.params.id) {
                this.isEditing = true;
                try {
                    const response = await this.$api.get(`/groups/${this.$route.params.id}`);
                    this.group = { ...response.data };
                } catch (error) {
                    this.errorMessage = 'Error fetching group data.';
                }
            }
        }
    },
    mounted() {
        this.fetchGroup();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
